import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { useContext, useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from 'react-redux';
import { treeActions } from '../../../redux/slices/treeSlice';
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep,isArray } from 'lodash';

export default function CustomDBField({updatedSelectedNode, modifyUpdatedNode, hasUpdatedNode}) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx)
  const { rightTree } = useSelector(state => state.treeData[parentScreen])
  const {translatedData, selectedNode} = rightTree.tree[rightTree.currentTab];
  const dispatch = useDispatch()

  const dbDefault = hasUpdatedNode ? (updatedSelectedNode?.LOOP_SOURCE_NAME || 'CUSTOM_DB_FIELD') : (selectedNode.LOOP_SOURCE_NAME || 'CUSTOM_DB_FIELD');
  const [dbField,setDBField] = useState(dbDefault);

  const handleDBFieldChange = (key, value) =>{
    setDBField(value)
    if (hasUpdatedNode) modifyUpdatedNode(key, value)
    else {
      const updatedData = eachDeep(cloneDeep(translatedData),obj =>{
        if (obj?.key !== selectedNode.key) {
          return;
        }
        obj[key] = value;
        if (isArray(obj?.children)) {
          return obj.children;
        }
      })
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: updatedData,
        })
      );
    }
  }

  const dbFieldOptions = [t('SELECT'), ...extractDBFieldNames(translatedData)]
    .map((obj, key) => (
    <MenuItem
      key={key}
      value={obj === t('SELECT') ? "CUSTOM_DB_FIELD" : obj}>
      {obj}
    </MenuItem>
  ));

  return (
    <>
      <FormControl variant='outlined' className='width-100' size='small'>
        <InputLabel> {t('CUSTOM_DB_FIELDS')} </InputLabel>
        <Select
          className='width-100'
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name='customDBField'
          value={dbField}
          label={t('CUSTOM_DB_FIELDS')}
          onChange={(e) => {
            handleDBFieldChange('LOOP_SOURCE_NAME', e.target.value)
          }}
        >
          {dbFieldOptions}
        </Select>
      </FormControl>
    </>
  )
}

const extractDBFieldNames = (data) => {
  const names = [];

  const extractNames = (obj) => {
    if (obj.TYPE === "QUERY" && obj.NAME) {
      names.push(obj.NAME);
    }

    if (obj.children && obj.children.length > 0) {
      obj.children.forEach(extractNames);
    }
  };

  data.forEach(extractNames);

  return names;
};